import { PlanType } from '@otter-ai/recall-client';
import { MAX_SEATS_PRO_PLAN } from '#constants';

export function validatedSeatCount({
  value,
  isEdu,
  planType,
}: {
  value: string;
  isEdu: boolean;
  planType: PlanType | null;
}) {
  // TODO add minimum seat calculation and default to minimum seat for business purchases
  const invalidInput = Number(value) <= 0;
  const invalidEdu = isEdu && Number(value) > 1;
  const invalidPro =
    planType === 'premium' && Number(value) > MAX_SEATS_PRO_PLAN;

  return !(invalidInput || invalidEdu || invalidPro);
}
